import { render } from "./PreviewPdf.vue?vue&type=template&id=dab5adb0&scoped=true&ts=true"
import script from "./PreviewPdf.vue?vue&type=script&lang=ts"
export * from "./PreviewPdf.vue?vue&type=script&lang=ts"

import "./PreviewPdf.vue?vue&type=style&index=0&id=dab5adb0&scoped=true&lang=css"

import exportComponent from "D:\\DefesaCivil\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dab5adb0"]])

export default __exports__